export default __webpack_public_path__ + "images/Healthy-Food.66d6e9.jpg";